import { Component, computed, effect, input, Input } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { UserGridItemObject } from '@it2go/types';
import { educationCodeToEnumOptions } from '@libs/types/src/user/enum/education.enum';
import { CardComponent } from '../../../../../components/kit/card/card.component';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';
import { TextInputComponent } from '../../../../../components/kit/input/text-input/text-input.component';
import { NumberInputComponent } from '../../../../../components/kit/input/text-input/number-input.component';
import { SearchDoctorSpecializationComponent } from 'packages/client/src/app/modules/content/components/common/search-doctor-specialization/search-doctor-specialization.component';

@Component({
    selector: 'app-user-personal-info',
    templateUrl: './user-personal-info.component.html',
    styleUrl: './user-personal-info.component.scss',
    imports: [
        CardComponent,
        SelectInputComponent,
        TextInputComponent,
        NumberInputComponent,
        SearchDoctorSpecializationComponent,
    ],
})
export class UserPersonalInfoComponent {
    @Input() form!: FormGroup;
    @Input() canEdit = false;
    public readonly user = input<UserGridItemObject | null>(null);

    protected isDoctor = computed(() => {
        const user = this.user();
        return !!user?.doctor || !!user?.employments?.some(e => e.employmentTypeName === 'doctor');
    });

    constructor() {
        effect(() => {
            const required = this.isDoctor();
            for (const name of ['icpOfDoctor', 'doctorSpecialization']) {
                const control = this.form.controls[name];
                if (required) control?.addValidators(Validators.required);
                else control?.removeValidators(Validators.required);
                control?.updateValueAndValidity({ emitEvent: false });
            }
        });
    }

    protected readonly educationCodeToEnumOptions = educationCodeToEnumOptions;
}
